/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import DataTable from "react-data-table-component";
import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { lensColumns } from "../constants";
import { LensRow } from "../../../constants";
import {roundToXDecimals} from "../../../../../../helpers/helpers";
import ArgosFlexbox from "../../../../../components/Containers/ArgosFlexbox";
import ArgosCollapseComponent from "../../../../../components/CollapseComponent/ArgosCollapseComponent";
import { theme } from "../../../../../../constants/theme";
import LensProperties from "../DetectionCapability/CollapsibleTabs/LensProperties";

import {ArgosTableSimple} from "../../../../../components/Table/ArgosTableSimple";


export const LensContent = (props: any) => {

  const [reactTableData, setReactTableData] = useState<LensRow[]>([]);
  const [baselineData, setBaselineData] = React.useState(props.baselineData);
  const [componentDataMap, setComponentDataMap] = useState({});

  useEffect(() => {
    convert_rows_list_to_object(props?.data)
  }, [props])

  const convert_rows_list_to_object = (rows: any[]) => {
    let new_format_rows: LensRow[] = []
    rows.forEach((row: any[]) => {
      let row_object: LensRow = {
        fov: roundToXDecimals(row[0], 3),
        paraxial_height: roundToXDecimals(row[1], 3),
        real_height: roundToXDecimals(row[2], 3),
        op_distance: roundToXDecimals(row[3], 3),
        angular_resolution: roundToXDecimals(row[4], 3),
      }
      new_format_rows.push(row_object)
    })
    setReactTableData(new_format_rows)
  }

  useEffect(() => {
    createCollapsibleTabs()
  }, [props])


  const createCollapsibleTabs = () => {
    let _componentDataMap : any = {}
    _componentDataMap["Lens Properties"] = <LensProperties
    baselineData={baselineData}
    sensorCameraData={props?.sensorCameraData}
    jsonData={props?.jsonData?.sensor}
      />
    setComponentDataMap(_componentDataMap)
  }

  return (
    <div>
      <ArgosCollapseComponent
        styleProps={{
          outlineOnly: true,
          fontColor: theme.layout.sidebar.backgroundColor,
        }}
        defaultOpen={true}
        data={componentDataMap ?? {}}
      />
      <ArgosFlexbox vertical style={{ overflow: 'auto', height: '100%', width: '100%' }}>
        <ArgosFlexbox style={{alignContent: 'center'}}>
          <ArgosTableSimple 
            data={reactTableData}
            columns={lensColumns}
            
            initialState={{density: 'compact'}}
            enableBottomToolbar
            enablePagination
          />
        </ArgosFlexbox>
      </ArgosFlexbox>
    </div>
  )
}